import { render, staticRenderFns } from "./purchase-types.vue?vue&type=template&id=232f5a82&"
import script from "./purchase-types.vue?vue&type=script&lang=js&"
export * from "./purchase-types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports